import http from './request'

// 任务列表
export const refEarnTaskList = (data) => {
  return http({
    url: '/advertCenter/Order/getTaskList',
    method: 'post',
    data
  })
}

// 领取新手任务
export const grabRefEarnGuideTask = (data) => {
  return http({
    url: '/advertCenter/Task/receiveNewHandTask',
    method: 'post',
    data
  })
}

// 下级列表
export const getSubUserList = (data) => {
  return http({
    url: '/promotion/SubUserStat/getPagedList',
    method: 'post',
    data
  })
}

// 获取职位汇总信息
export const getUserPositionInfo = (data) => {
  return http({
    url: '/promotion/UserPosition/getInfo',
    method: 'post',
    data
  })
}

// 获取邀请人数和总佣金
export const getRefEarnAgentInfo = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getInfo',
    method: 'post',
    data
  })
}

// 获取裂变任务裂变
export const getRefEarnAgentTasks = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getTasks',
    method: 'post',
    data
  })
}
